import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import LogoImage from '../assets/logo.png'; // Update this path to match your logo location

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeaderContainer scrolled={scrolled} id="top">
      <div className="container">
        <BrandContainer>
          <LogoWrapper>
            <img src={LogoImage} alt="The Coach House Logo" />
          </LogoWrapper>
          <TextContainer>
            <h1>The Coach House</h1>
            <span>with Samantha Knowles</span>
            {/* <span>with Samantha Knowles</span> */}
          </TextContainer>
        </BrandContainer>
        
        <MobileMenuButton onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </MobileMenuButton>
        
        <NavContainer open={menuOpen}>
          <NavItem>
            <Link to="about" smooth={true} duration={800} onClick={() => setMenuOpen(false)}>
              About
            </Link>
          </NavItem>
          <NavItem>
            <Link to="services" smooth={true} duration={800} onClick={() => setMenuOpen(false)}>
              Services
            </Link>
          </NavItem>
          <NavItem>
            <Link to="testimonials" smooth={true} duration={800} onClick={() => setMenuOpen(false)}>
              Testimonials
            </Link>
          </NavItem>
          <NavItem>
            <Link to="contact" smooth={true} duration={800} onClick={() => setMenuOpen(false)}>
              Contact
            </Link>
          </NavItem>
          <NavButton>
            <Link to="booking" smooth={true} duration={800} onClick={() => setMenuOpen(false)}>
              Book a Call
            </Link>
          </NavButton>
        </NavContainer>
      </div>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 0;
  z-index: 1000;
  transition: all 0.3s ease;
  background-color: ${props => props.scrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent'};
  box-shadow: ${props => props.scrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none'};

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const BrandContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoWrapper = styled.div`
  height: 60px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  
  img {
    height: 100%;
    width: auto;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  h1 {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.8rem;
    margin: 0;
    line-height: 1.2;
    color: #1A2A3A;
  }
  
  span {
    font-size: 0.9rem;
    color: #5A7F8C;
    line-height: 1;
  }
`;

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 80px;
    right: ${props => props.open ? '0' : '-100%'};
    width: 70%;
    height: calc(100vh - 80px);
    background-color: white;
    flex-direction: column;
    padding: 40px 20px;
    transition: right 0.3s ease;
    box-shadow: -2px 0 10px rgba(0,0,0,0.1);
  }
`;

const NavItem = styled.div`
  margin: 0 15px;
  
  a {
    text-decoration: none;
    color: #1A2A3A; /* Updated to match hero headline color */
    font-weight: 500;
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 0;
      height: 2px;
      background-color: #A8C4A0;
      transition: width 0.3s ease;
    }
    
    &:hover:after {
      width: 100%;
    }
  }
  
  @media (max-width: 768px) {
    margin: 15px 0;
  }
`;

const NavButton = styled.div`
  margin-left: 15px;
  
  a {
    display: inline-block;
    padding: 10px 20px;
    background-color: #A8C4A0;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-weight: 600;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #97b38f;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    }
  }
  
  @media (max-width: 768px) {
    margin: 15px 0 0 0;
    width: 100%;
    
    a {
      display: block;
      text-align: center;
    }
  }
`;

const MobileMenuButton = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #1A2A3A; /* Updated to match hero headline color */
    margin-bottom: 5px;
    border-radius: 3px;
    transition: all 0.3s ease;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  @media (max-width: 768px) {
    display: flex;
  }
`;

export default Header;